import { useState } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import useSessionStore from 'store/session';


function ConfigModal({close, dismiss}) {
  const [sessionStore, sessionStoreActions] = useSessionStore();
  const [chartFidelity, setChartFidelity] = useState(sessionStore.chartFidelity);

  async function finish() {
    sessionStoreActions.setChartFidelity(chartFidelity);
    close();
  }

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>Settings for Circuit Historical Charts</Trans></h3>
      </header>
      <section>
        <ul className="form">
          <li>
            <label htmlFor="chartFidelity"><Trans>Chart Fidelity</Trans></label>
            <select id="chartFidelity" value={chartFidelity} onChange={(e) => setChartFidelity(Number(e.target.value))}>
              <option value="0.5"><Trans>Low (Faster Loading)</Trans></option>
              <option value="1"><Trans>Normal</Trans></option>
              <option value="6"><Trans>High (Slower Loading)</Trans></option>
              <option value="12"><Trans>Max (All available data points)</Trans></option>
            </select>
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary`}
          onClick={finish}
        >
          <Trans>Update</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default ConfigModal;
